import type { ProductAttributeOption } from "@/modules/offers/types/createOffer"
import type { ProductModerationAttributeValue } from "@/modules/offers/types/offers"

export const getAttributeLabel = (attribute: ProductAttributeOption) =>
  attribute.public_name_mlang?.uk || attribute.public_name_mlang?.ru || attribute.public_name

export const getAttributeValueLabel = (value: ProductModerationAttributeValue) =>
  value.value_mlang?.uk || value.value_mlang?.ru || value.value
